module.exports = __webpack_public_path__ + "static/Home2_Hover-58cfe767a2bce8ac615b17106b683ca8.png";